var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlash = function SvgFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6859 10.7199H14.7131V3.5199C14.7131 1.8399 13.8376 1.4999 12.7697 2.7599L12 3.6699L5.48671 11.3699C4.59197 12.4199 4.96718 13.2799 6.3141 13.2799H9.28693V20.4799C9.28693 22.1599 10.1624 22.4999 11.2303 21.2399L12 20.3299L18.5133 12.6299C19.408 11.5799 19.0328 10.7199 17.6859 10.7199Z",
    fill: "#037DD6"
  })));
};
export default SvgFlash;